import { PageId } from 'constants/pages'

export const enum PageIdStylioArch {
  AGE_ARCH = PageId.AGE_ARCH,
  SHOP_SMARTER_ARCH = PageId.SHOP_SMARTER_ARCH,
  STYLIO_TO_HELP_ARCH = PageId.STYLIO_TO_HELP_ARCH,
  MAIN_GOAL_ARCH = PageId.MAIN_GOAL_ARCH,
  WHERE_TO_SHOP_ARCH = PageId.WHERE_TO_SHOP_ARCH,
  WARDROBE_PERCENTAGE_ARCH = PageId.WARDROBE_PERCENTAGE_ARCH,
  HAIR_COLOR_ARCH = PageId.HAIR_COLOR_ARCH,
  EYES_COLOR_ARCH = PageId.EYES_COLOR_ARCH,
  SKIN_COLOR_ARCH = PageId.SKIN_COLOR_ARCH,
  CLIMAT_ARCH = PageId.CLIMAT_ARCH,
  BODY_SHAPE_ARCH = PageId.BODY_SHAPE_ARCH,
  URGE_1_ARCH = PageId.URGE_1_ARCH,
  URGE_2_ARCH = PageId.URGE_2_ARCH,
  URGE_3_ARCH = PageId.URGE_3_ARCH,
  URGE_4_ARCH = PageId.URGE_4_ARCH,
  URGE_5_ARCH = PageId.URGE_5_ARCH,
  URGE_6_ARCH = PageId.URGE_6_ARCH,
  URGE_7_ARCH = PageId.URGE_7_ARCH,
  URGE_8_ARCH = PageId.URGE_8_ARCH,
  URGE_9_ARCH = PageId.URGE_9_ARCH,
  STYLE_PROFILE_ARCH = PageId.STYLE_PROFILE_ARCH,
  WARDROBE_READY_ARCH = PageId.WARDROBE_READY_ARCH,
  NOTHING_TO_WEAR_ARCH = PageId.NOTHING_TO_WEAR_ARCH,
  ARCHETYPE_INTRO_ARCH = PageId.ARCHETYPE_INTRO_ARCH,
  DRESSED_FEEL_ARCH = PageId.DRESSED_FEEL_ARCH,
  STYLE_MATTERS_MOST_ARCH = PageId.STYLE_MATTERS_MOST_ARCH,
  OUTFIT_VIBE_ARCH = PageId.OUTFIT_VIBE_ARCH,
  OUTFIT_COMPLIMENT_ARCH = PageId.OUTFIT_COMPLIMENT_ARCH,
  SHOP_PULLS_FIRST_ARCH = PageId.SHOP_PULLS_FIRST_ARCH,
  ARCHETYPE_LOADING_ARCH = PageId.ARCHETYPE_LOADING_ARCH,
  ARCHETYPE_RESULT_ARCH = PageId.ARCHETYPE_RESULT_ARCH,
  LOOKING_FEMININE_ARCH = PageId.LOOKING_FEMININE_ARCH,
  STYLES_FEEL_LIKE_YOU_ARCH = PageId.STYLES_FEEL_LIKE_YOU_ARCH,
  TALL_ARCH = PageId.TALL_ARCH,
  WEIGHT_ARCH = PageId.WEIGHT_ARCH,
  WARDROBE_CHANGED_ARCH = PageId.WARDROBE_CHANGED_ARCH,
  FAVORITE_COLORS_ARCH = PageId.FAVORITE_COLORS_ARCH,
  LIKE_OR_DISLIKE_11_ARCH = PageId.LIKE_OR_DISLIKE_11_ARCH,
  LIKE_OR_DISLIKE_14_ARCH = PageId.LIKE_OR_DISLIKE_14_ARCH,
  LIKE_OR_DISLIKE_15_ARCH = PageId.LIKE_OR_DISLIKE_15_ARCH,
  LIKE_OR_DISLIKE_18_ARCH = PageId.LIKE_OR_DISLIKE_18_ARCH,
  LIKE_OR_DISLIKE_19_ARCH = PageId.LIKE_OR_DISLIKE_19_ARCH,
  WALK_INTO_ROOM_ARCH = PageId.WALK_INTO_ROOM_ARCH,
  PERFECT_WEEKEND_ARCH = PageId.PERFECT_WEEKEND_ARCH,
  WARDROBE_FEEL_ARCH = PageId.WARDROBE_FEEL_ARCH,
  SHOPPING_ARCH = PageId.SHOPPING_ARCH,
  SHOPPING_BUDGET_ARCH = PageId.SHOPPING_BUDGET_ARCH,
  SHOPPING_PRIORITY_ARCH = PageId.SHOPPING_PRIORITY_ARCH,
  AMAZON_FRUSTRATION_ARCH = PageId.AMAZON_FRUSTRATION_ARCH,
  CURATED_LINKS_ARCH = PageId.CURATED_LINKS_ARCH,
  LIFESTYLE_FOCUS_ARCH = PageId.LIFESTYLE_FOCUS_ARCH,
  OUTFIT_NEEDS_ARCH = PageId.OUTFIT_NEEDS_ARCH,
  WARDROBE_ALIGNS_ARCH = PageId.WARDROBE_ALIGNS_ARCH,
  LIFESTYLE_CHANGES_ARCH = PageId.LIFESTYLE_CHANGES_ARCH,
  STYLE_DRAWN_TO_ARCH = PageId.STYLE_DRAWN_TO_ARCH,
  OUTFIT_EMOTION_ARCH = PageId.OUTFIT_EMOTION_ARCH,
  STYLE_DISCOVERY_ARCH = PageId.STYLE_DISCOVERY_ARCH,
  WARDROBE_COLORS_ARCH = PageId.WARDROBE_COLORS_ARCH,
  COLOR_CONFIDENCE_ARCH = PageId.COLOR_CONFIDENCE_ARCH,
  BODY_SHAPE_CONFIDENCE_ARCH = PageId.BODY_SHAPE_CONFIDENCE_ARCH,
  SHOW_OFF_FEATURES_ARCH = PageId.SHOW_OFF_FEATURES_ARCH,
  PREPARE_FLOW_ARCH = PageId.PREPARE_FLOW_ARCH,
  EMAIL_ARCH = PageId.EMAIL_ARCH,
  EMAIL_CONSENT_ARCH = PageId.EMAIL_CONSENT_ARCH,
  NAME_ARCH = PageId.NAME_ARCH,
  READINESS_LEVEL_ARCH = PageId.READINESS_LEVEL_ARCH,
  PRE_PAYWALL_OFFER_ARCH = PageId.PRE_PAYWALL_OFFER_ARCH,
  SUBSCRIPTIONS_ARCH = PageId.SUBSCRIPTIONS_ARCH,
  CANCEL_OFFER_ARCH = PageId.CANCEL_OFFER_ARCH,
  SUB_UPSELL_ARCH = PageId.SUB_UPSELL_ARCH,
  UPSELL_ARCH = PageId.UPSELL_ARCH,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_ARCH = PageId.DOWNLOAD_ARCH,
}
